/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  Dropdown as RSDropdown,
  DropdownToggle as RSDropdownToggle,
  DropdownMenu as RSDropdownMenu,
  DropdownItem as RSDropdownItem,
} from 'reactstrap';
import sharedStyles from '../../styles/shared.css';
import styles from './styles.css';

class CustomRSDropdown extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.node,
        value: PropTypes.string,
        displayValue: PropTypes.string, // This value will be displayed as selected value dropdown UI when dropdown is closed
        isGroup: PropTypes.bool,
      }),
    ).isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    keepOpen: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    placeholder: '',
    onChange: () => { },
    keepOpen: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      isOpen: false,
      keepOpen: this.props.keepOpen,
      selectedItem: {},
    };
  }

  closeDropdown = (newComparisonMetric) => {
    if (!newComparisonMetric) {
      this.setState(() => ({
        isOpen: false,
      }));
      return;
    }
    this.setState(prevState => ({
      isOpen: false,
      currentComparisonMetric: newComparisonMetric || prevState.currentComparisonMetric,
    }));
  }

  globalOnClickHandler = (event) => {
    const { isOpen, keepOpen } = this.state;

    if (isOpen && !keepOpen) {
      if (this.dropdownRef && !this.dropdownRef.getContainer().contains(event.target)) {
        this.closeDropdown();
      }
    }
  }

  toggle = () => {
    const { isOpen } = this.state;
    if (!isOpen) {
      this.setState(() => ({
        isOpen: true,
      }));
    }
  }

  handleOnDropdownItemClick = (e) => {
    const { value: targetValue } = e.target.dataset;
    const { displayValue, value: currentTargetValue } = e.currentTarget.dataset;

    // If consumer's custom button etc is set as dropdown item and if that custom item was clicked
    // don't consider it as drop-down-item clicked
    if (targetValue && targetValue === currentTargetValue) {
      const selectedItem = {
        displayValue,
        value: targetValue,
      };

      this.setState(() => ({ selectedItem }));
      this.props.onChange(selectedItem);

      const { keepOpen } = this.state;
      if (!keepOpen) {
        this.closeDropdown();
      }
    } else {
      this.setState(() => ({ selectedItem: {} }));
    }
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.globalOnClickHandler);
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.globalOnClickHandler);
  }

  componentDidUpdate = (prevProps) => {
    const { options, keepOpen } = this.props;

    if (!_.isEqual(this.props.options, prevProps.options) || keepOpen !== prevProps.keepOpen) {
      this.setState(() => ({ options, keepOpen }));
    }
  }

  render() {
    const { className, placeholder } = this.props;
    const { options, isOpen, selectedItem } = this.state;

    return (
      <RSDropdown
        className={`${sharedStyles.rsDropdown} ${styles.customRSDropdown} ${className}`}
        isOpen={isOpen}
        toggle={this.toggle}
        ref={(el) => { this.dropdownRef = el; }}
        direction="down"
      >
        <RSDropdownToggle
          caret
          className={sharedStyles.rsDropdownToggle}
          style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        >
          <span>{selectedItem.displayValue || placeholder}</span>
          <FontAwesomeIcon className={sharedStyles.rsDropdownChevron} icon={isOpen ? faChevronUp : faChevronDown} />
        </RSDropdownToggle>

        <RSDropdownMenu className={`${sharedStyles.rsDropdownMenu} ${styles.dropdownMenu}`}>
          {options.map((o) => {
            if (o.isGroup) {
              return (
                <div key={o.value} className={styles.optionsGroup}>
                  {o.label}
                </div>
              );
            }
            return (
              <RSDropdownItem
                key={o.value}
                className={styles.dropdownItem}
                onClick={this.handleOnDropdownItemClick}
                data-value={o.value}
                data-display-value={o.displayValue}
                data-label={o.label}
              >
                {o.label}
              </RSDropdownItem>
            );
          })}
        </RSDropdownMenu>

      </RSDropdown>
    );
  }
}

export default CustomRSDropdown;
